import React from 'react';
export const ConnectCar = React.lazy(() => import('./ConnectCar'));
